<!-- =========================================================================================
  File Name: TheNavbar.vue
  Description: Navbar component
  Component Name: TheNavbar
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="relative">
    <vs-popup class="holamundo" title="Login" :active.sync="popup">
      <div class="p-2">
        <div v-if="!magicLinkSent">
          <h5 class="font-extrabold mb-4">
            Enter your email to receive magic link
          </h5>
          <vx-input-group>
            <vs-input
              v-validate="'required|email|min:3'"
              data-vv-validate-on="blur"
              :disabled="otpSent"
              name="Email"
              icon-no-border
              icon="icon icon-mail"
              icon-pack="feather"
              v-model="email"
              class="w-full mr-3"
            />
            <template slot="append">
              <div class="append-text btn-addon">
                <vs-button
                  class="btn btn-icon"
                  :color="
                    $route.path.includes('gala')
                      ? '#3089f0'
                      : $route.path.includes('emotionhack')
                      ? '#7B40E9'
                      : '#7B40E9'
                  "
                  :disabled="!email"
                  @click="sendMeMagicLink()"
                >
                  <feather-icon icon="LogInIcon" />
                </vs-button>
              </div>
            </template>
          </vx-input-group>
          <span class="text-danger text-sm">{{ errors.first("Email") }}</span>
        </div>
        <div v-else class="items-center">
          <div class="mb-base">
            <p class="font-extrabold mb-3">Magic link sent on {{ email }}</p>
            <p>Please check you email</p>
          </div>
          <small>Did not receive?</small>
          <vs-button
            class="block"
            :color="
              $route.path.includes('gala')
                ? '#3089f0'
                : $route.path.includes('emotionhack')
                ? '#7B40E9'
                : '#7B40E9'
            "
            @click.stop="sendMeMagicLink()"
            >Resend Magic Link</vs-button
          >
        </div>
      </div>
    </vs-popup>

    <vs-popup
      fullscreen
      class="profile-card"
      title="Editor"
      :active.sync="flag"
    >
      <iframe
        :src="`/gala/editor/preview?organization='gala'`"
        fullscreen
        frameBorder="0"
        id="editorGala1"
        class="editor-iframe"
      ></iframe>
    </vs-popup>
    <div class="vx-navbar-wrapper">
      <vs-navbar
        class="vx-navbar navbar-custom navbar-skelton"
        :class="$route.path.includes('dark') ? 'dark-bg-gala' : ''"
        :color="navbarColor"
      >
        <!-- SM - OPEN SIDEBAR BUTTON -->
        <img
          v-if="defaltLogo && $route.path.includes('dark') === false"
          src="../../../../src/assets/images/logo/getboarded-logo.svg"
          class="logo-gala"
        />

        <img
          v-else-if="$route.path.includes('dark')"
          src="../../../../src/assets/images/gala-images/dark-theme/logo.svg"
          class="logo-gala"
        />

        <img
          v-else
          src="../../../../src/assets/images/gala-images/logo_branded/logo_latest.svg"
          class="logo-gala"
        />

        <!--        <feather-icon-->
        <!--          v-else-->
        <!--          class="sm:inline-flex xl:hidden cursor-pointer p-2"-->
        <!--          icon="MenuIcon"-->
        <!--          @click.stop="showSidebar"-->
        <!--        />-->

        <!--<bookmarks :navbarColor="navbarColor" v-if="windowWidth >= 992" />-->
        <!-- <router-link
          v-if="organizationSlug === 'dpd-belux'"
          tag="div"
          :to="alexPage && organizationSlug ? `/${organizationSlug}/alex` : '/'"
          class="vx-logo cursor-pointer ml-5 mx-auto flex items-center"
        >
          <span
            class="navbar-menu-item alex-profile"
            :class="alexPage ? 'alex-nav' : 'gtb-nav'"
          >
            <img
              src="../../../../src/assets/images/pages/gala/gala-logo.svg"
              width="220px"
              class="mb-2 mt-12"
            /></span>
        </router-link> -->

        <router-link
          v-if="$route.path.includes('gala')"
          tag="div"
          :to="`/${organizationSlug_}/journey`"
          class="vx-logo cursor-pointer ml-5 mx-auto flex items-center"
        >
          <!--<logo class="w-10 mr-4 fill-current text-primary" />-->
          <span class="navbar-menu-item" :class="alexPage ? '' : 'gtb-nav'">
            <div
              v-if="windowWidth < 600"
              class="navbar-menu-item"
              title="Share your qualifications, career history and interest"
            >
              <vs-button
                @click="openEditor"
                v-if="isUserLoggedIn && $route.path.includes('dark') === false"
                class="gala-btn"
                :class="localThemeBtnClass"
                color="#3089f0"
              >
                My Player Profile
              </vs-button>

              <span
                class="flex items-center justify-center"
                @click="openEditor"
                v-else-if="
                  isUserLoggedIn &&
                  galaAvatarCheck &&
                  $route.path.includes('dark')
                "
                ><img
                  class="w-full md:h-12"
                  src="../../../../src/assets/images/gala-images/dark-theme/btn.png"
                  alt=""
                />
                <h3 class="text-gear absolute">Gala Character</h3>
              </span>

              <vs-button
                v-else
                @click="verifyEmail"
                :class="localThemeBtnClass"
                color="#3089f0"
              >
                Login</vs-button
              >
            </div></span
          >
        </router-link>
        <router-link
          v-else-if="organizationSlug && defaltLogo"
          tag="div"
          :to="`/${organizationSlug}/journey`"
          class="vx-logo cursor-pointer ml-5 mx-auto flex items-center"
        >
          <!--<logo class="w-10 mr-4 fill-current text-primary" />-->
          <!--          <span-->
          <!--            class="navbar-menu-item alex-profile"-->
          <!--            :class="alexPage ? 'alex-nav' : 'gtb-nav'"-->
          <!--          >GetBoarded</span-->
          <!--          >-->
        </router-link>
        <router-link
          v-else
          tag="div"
          :to="'/'"
          class="vx-logo cursor-pointer ml-5 mx-auto flex items-center"
        >
          <!--<logo class="w-10 mr-4 fill-current text-primary" />-->
          <!--          <span-->
          <!--            class="navbar-menu-item alex-profile"-->
          <!--            :class="alexPage ? 'alex-nav' : 'gtb-nav'"-->
          <!--            style="color: #231d4f"-->
          <!--          >GetBoarded</span-->
          <!--          >-->
        </router-link>

        <vs-spacer />

        <!--<search-bar />-->

        <!--<notification-drop-down />-->
        <template v-if="alexPage && windowWidth > 1200">
         <div
            class="navbar-menu-item alex-profile"
            title="Share your qualifications, career history and interest"
            v-if="organizationSlug === 'dpd-belux'"
          >
            <vs-button
              @click="openEditor"
              :class="localThemeBtnClass"
              :color="localThemeColor"
            >
              My {{ organizationName }} Character</vs-button
            >
          </div>
          <div
            class="navbar-menu-item alex-profile"
            title="Share your qualifications, career history and interest"
            v-else-if="$route.path.includes('gala')"
          >
            <vs-button
              @click="openEditor"
              v-if="isUserLoggedIn && galaAvatarCheck"
              :class="localThemeBtnClass"
              color="#3089f0"
            >
              My Player Profile</vs-button
            >

            <vs-button
              @click="$router.push('/login')"
              v-else-if="endorsementCheck && !isUserLoggedIn"
              :class="localThemeBtnClass"
              color="#3089f0"
            >
              Login</vs-button
            >
            <vs-button
              v-else-if="isUserLoggedIn"
              @click="openEditor"
              :class="localThemeBtnClass"
              color="#3089f0"
            >
              My Player Profile</vs-button
            >
            <vs-button
              v-else
              @click="verifyEmail"
              :class="localThemeBtnClass"
              color="#3089f0"
            >
              Login</vs-button
            >
          </div>
          <div
            class="navbar-menu-item alex-profile"
            title="Share your qualifications, career history and interest"
            v-else-if="$route.path.includes('emotionhack')"
          >
            <vs-button
              @click="logout"
              v-if="isUserLoggedIn"
              :class="localThemeBtnClass"
              color="#7B40E9"
            >
              Logout</vs-button
            >
            <vs-button
              v-else
              @click="verifyEmail"
              :class="localThemeBtnClass"
              color="#7B40E9"
            >
              Login</vs-button
            >
          </div>
        </template>
        <template
          class="dark-bg-gala"
          v-else-if="$route.path.includes('dark') && windowWidth > 1200"
        >
          <div
            class="navbar-menu-item alex-profile alex-profile--sm"
            title="Share your qualifications, career history and interest"
          >
            <span
              class="flex items-center justify-center"
              @click="openEditor"
              v-if="isUserLoggedIn && galaAvatarCheck"
              ><img
                class="w-full md:h-12"
                src="../../../../src/assets/images/gala-images/dark-theme/btn.png"
                alt=""
              />
              <h3 class="text-gear absolute">Gala Character</h3>
            </span>

            <span
              class="flex items-center justify-center"
              @click="$router.push('/login')"
              v-else-if="endorsementCheck && !isUserLoggedIn"
              ><img
                class="w-100 md:h-12"
                src="../../../assets/images/gala-images/dark-theme/btn.png"
                alt=""
              />
              <h3 class="text-gear absolute">Login</h3>
            </span>

            <span
              class="flex items-center justify-center"
              @click="verifyEmail"
              v-else
              ><img
                class="w-100 md:h-12"
                src="../../../assets/images/gala-images/dark-theme/btn.png"
                alt=""
              />
              <h3 class="text-gear absolute">Login</h3>
            </span>
          </div></template
        >
        <template v-else>
          <!-- <div class="navbar-menu-item mr-10" v-if="windowWidth > 1200">
            Home
          </div>
          <div class="navbar-menu-item mr-10" v-if="windowWidth > 1200">
            Features
          </div>
          <div class="navbar-menu-item mr-10" v-if="windowWidth > 1200">
            Pricing
          </div>
          <div class="navbar-menu-item mr-10" v-if="windowWidth > 1200">
            Contact
          </div> -->

          <div v-if="windowWidth > 1200">
            <!-- <vs-button
              class="login-btn mr-5"
              type="border"
              :color="localThemeColor"
              >Login</vs-button
            > -->
            <vs-button
              v-if="!isUserLoggedIn"
              @click.stop="goToLogin()"
              class="get-started-btn"
              :class="localThemeBtnClass"
              :color="localThemeColor"
              >Get Started</vs-button
            >
            <vs-button
              v-else-if="organizationSlug === 'gala' && isUserLoggedIn"
              @click.stop="goToDashboard()"
              class="get-started-btn"
              :class="localThemeBtnClass"
              color="#3089f0"
              >Visit your Dashboard</vs-button
            >
            <vs-button
              v-else-if="organizationSlug === 'emotionhack' && isUserLoggedIn"
              @click.stop="goToDashboard()"
              class="get-started-btn"
              :class="localThemeBtnClass"
              color="#7B40E9"
              >Visit your Dashboard</vs-button
            >
            <vs-button
              v-else
              @click.stop="goToDashboard()"
              class="get-started-btn"
              :class="localThemeBtnClass"
              :color="localThemeColor"
              >Visit your Dashboard</vs-button
            >
          </div>
        </template>

        <!--<profile-drop-down />-->
      </vs-navbar>
    </div>
  </div>
</template>


<script>
import Bookmarks from "./components/Bookmarks.vue";
import SearchBar from "./components/SearchBar.vue";
import NotificationDropDown from "./components/NotificationDropDown.vue";
import ProfileDropDown from "./components/ProfileDropDown.vue";
import { sendMeOTPService, verifyOTPService } from "@/services/auth.service.js";

export default {
  name: "the-navbar-vertical",
  data() {
    return {
      scrollPosition: null,
      org: "",
      userId: "",
      boardSlug: "",
      endorsementCheck: "",
      defaltLogo: "",
      flag: false,
      email: "",
      authPopup: false,
      otp: "",
      popup: false,
      magicLinkSent: false,
      organizationSlug_: "gala",
    };
  },
  props: {
    navbarColor: {
      type: String,
      default: "#000000",
    },
  },
  components: {
    Bookmarks,
    SearchBar,
    NotificationDropDown,
    ProfileDropDown,
  },
  computed: {
    isUserLoggedIn() {
      return this.$store.state.auth.isUserLoggedIn;
    },
    isAccessTokenSet() {
      return (
        localStorage.getItem("accessToken") &&
        localStorage.getItem("accessToken").length
      );
    },
    galaAvatarCheck() {
      console.log(
        "this.$store.state.users.data.galaAvatar;",
        this.$store.state.users.data
      );
      return this.$store.state.users.data.galaAvatar;
    },
    navbarColorLocal() {
      return this.$store.state.theme === "dark" &&
        this.navbarColor === "#000000"
        ? "#10163a"
        : this.navbarColor;
    },
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth;
    },
    textColor() {
      return {
        "text-whit":
          (this.navbarColor !== "#10163a" &&
            this.$store.state.theme === "dark") ||
          (this.navbarColor !== "#000000" &&
            this.$store.state.theme !== "dark"),
      };
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },
    otpSent() {
      return this.$store.state.auth.otpSent;
    },
    // NAVBAR STYLE
    classObj() {
      if (this.verticalNavMenuWidth == "default") return "navbar-default";
      else if (this.verticalNavMenuWidth == "reduced") return "navbar-reduced";
      else if (this.verticalNavMenuWidth) return "navbar-full";
    },
    currentPage() {
      return this.$store.state.pageType;
    },
    staticNavbarPage() {
      if (
        this.currentPage !== "privacyPolicy" &&
        this.currentPage !== "gdprCompliance" &&
        this.currentPage !== "cookiePolicy" &&
        this.currentPage !== "termsOfUse" &&
        this.currentPage !== "parser" &&
        this.currentPage !== "alex-curate" &&
        this.currentPage !== "alex-customize" &&
        this.currentPage !== "alex-connect" &&
        this.currentPage !== "marketplace"
      ) {
        return true;
      }
    },
    localThemeBtnClass() {
      if (this.$store.state.pageType === "university") {
        return "get-started-btn-univ";
      } else if (this.$store.state.pageType === "company") {
        return "get-started-btn-comp";
      } else if (this.$store.state.pageType === "alex") {
        return "get-started-btn-alex";
      } else if (this.$store.state.pageType === "alex") {
        return "get-started-btn-alex";
      } else {
        return "get-started-btn-others";
      }
    },
    localThemeColor() {
      if (this.$store.state.pageType === "university") {
        return "#27A949";
      } else if (this.$store.state.pageType === "company") {
        return "#3F74BA";
      } else if (
        this.$store.state.pageType === "alex" ||
        this.$store.state.pageType === "alex-curate" ||
        this.$store.state.pageType === "alex-customize" ||
        this.$store.state.pageType === "alex-connect"
      ) {
        return "#E71B44"; // '#44CC88';
      } else {
        return "#F29300";
      }
    },
    alexPage() {
      if (
        this.$store.state.pageType === "alex" ||
        this.$store.state.pageType === "alex-curate" ||
        this.$store.state.pageType === "alex-customize" ||
        this.$store.state.pageType === "alex-connect"
      ) {
        return true;
      }
      return false;
    },
    organizationSlug() {
      return this.$store.state.organization.orgData.slug;
    },
    organizationName() {
      return this.$store.state.organization.orgData.name;
    },
  },
  watch: {
    galaAvatarCheck() {
      this.$forceUpdate();
    },
    isAccessTokenSet() {
      console.log("isAccessTokenSet");
      window.location.reload();
    },
  },
  created() {
    let url = this.$route.path.split("/");
    const orgSlug = url[1];
    if (url[1] === "parser") {
      this.defaltLogo = url[1];
    } else {
      this.defaltLogo = url[3];
    }
      this.organizationSlug_ = orgSlug;
      if (orgSlug) {
        this.$store
          .dispatch("organization/fetchOrganizationBySlug", orgSlug)
          .then((res) => {
            console.log("res.data", res.data.data[0]);
            // this.organizationSlug = res.data.data[0].slug;
            this.organizationName = res.data.data[0].name;
            if (!res.data.data[0].activeMarketplace) this.$router.push("/");
            else {
              this.$store.dispatch("journey/fetchUserSegments", {
                orgId: res.data.data[0]._id,
              });
            }
          })
          .catch((err) => {
            throw err;
          });
    }
    this.boardSlug = url[2];
    this.userId = url[3];
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    verifyEmail() {
      this.popup = true;
    },
    // sendMeOTP() {
    //   const payload = {
    //     email: this.email,
    //     password: this.email,
    //     currentThis: this,
    //     userSource: "editor",
    //   };
    //   sendMeOTPService(payload);
    // },
    // verifyOTP() {
    //   let url = this.$route.path.split("/");
    //   const organizationSlug = url[1];
    //   const userId = this.$route.params.userId;
    //   const payload = {
    //     email: this.email,
    //     otp: this.otp,
    //     userId: userId,
    //     organizationSlug: organizationSlug,
    //     currentThis: this,
    //   };
    //   this.popup = false;
    //   verifyOTPService(payload);
    // },
    async sendMeMagicLink() {
      this.$store
        .dispatch("auth/sendMeMagicLink", {
          email: this.email,
          redirectTo: `/${this.organizationSlug_}/journey`,
          emailSubject: "Journey App | Magic Link | GetBoarded",
        })
        .then(() => {
          this.magicLinkSent = true;
          this.$vs.notify({
            title: "Magic link sent",
          });
        })
        .catch(() => {
          this.$vs.notify({
            title: "Unauthorized Access or Unexpected Error",
            text: "Please contact the administrator",
            color: "danger",
          });
        });
    },
    logout() {
      //TalentPaint Session Destroy For Alex
      this.$store.dispatch(
        "alex/deleteSession",
        this.$store.state.auth.user._id
      );
      //TalentPaint Session Destroy For Gala Or Journey App
      this.$store.dispatch(
        "boards/deleteSession",
        this.$store.state.auth.user._id
      );
      //Youlab Session Destroy For Gala Or Journey App
      this.$store.dispatch(
        "editor/deleteSession",
        this.$store.state.auth.user._id
      );

      this.$store.dispatch("auth/logout").then((res) => {
        if (this.organizationSlug === "default")
          window.location.href = `/${this.organizationSlug_}/journey`;
        else window.location.href = `/${this.organizationSlug_}/journey`;
      });
    },
    handleScroll() {
      this.scrollPosition = window.scrollY;
    },
    showSidebar() {
      this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", true);
    },
    openEditor() {
      this.flag = true;
      document
        .getElementById("editorGala1")
        .contentWindow.location.reload(true);
    },
    goToLogin() {
      window.location.href = "/login";
    },
    goToDashboard() {
      window.location.href = "/user/dashboard";
    },
  },
  mounted() {
    let url = this.$route.path.split("/");
    if (url[3] === "identify_competencies") {
      this.endorsementCheck = true;
    } else {
      const userId = url[3];
    }

    if (this.isUserLoggedIn) {
      this.popup = false;
      this.$vs.loading();
      this.$store
        .dispatch("users/fetchUser", this.$store.state.auth.user._id)
        .then((res) => {
          // console.log('userData', res.data);

          this.$store.commit(
            "editor/SET_PERSONAL_EVALUATION",
            res.data.personalEvaluation[0]
          );
          this.$store.commit(
            "editor/SET_CAREER_HISTORY",
            res.data.careerHistory
          );
          this.$store.commit(
            "editor/SET_EDUCATIONAL_QUALIFICATIONS",
            res.data.educationalQualifications
          );
          this.$store.commit("editor/SET_PROJECTS", res.data.projects);
          this.$store.commit(
            "editor/SET_EXTRA_CURRICULAR",
            res.data.extraCurricular[0]
          );
          this.$store.commit("editor/SET_PERSONALITY", res.data.personality[0]);
          this.$store
            .dispatch(
              "boards/fetchUserBoardData",
              this.$store.state.auth.user._id
            )
            .then((res) => {
              this.$vs.loading.close();
            })
            .catch((err) => {
              throw err;
            });
        })
        .catch((err) => {
          throw err;
        });
    }
  },
};
</script>

<style scoped>
button {
  border-radius: 50px;
  font-style: normal;
  font-weight: 500;
  /*font-size: 18px;*/
  /*line-height: 22px;*/
  /* identical to box height */

  /*letter-spacing: -0.01em;*/
}
.vx-navbar {
  padding: 2rem;
}
.vx-navbar-scroll {
  box-shadow: none !important;
  background-color: transparent !important;
  color: white !important;
}
.vx-navbar-scroll .vx-logo-text {
  color: #000000;
}
.vx-navbar-scroll .login-btn {
  color: white !important;
  border-color: white !important;
}
.vx-navbar-scroll .get-started-btn {
  /*color: #F29300;*/
  background-color: white !important;
}
.vx-navbar-scroll .get-started-btn-univ {
  color: #27a949;
}
.vx-navbar-scroll .get-started-btn-comp {
  color: #3f74ba;
}
.vx-navbar-scroll .get-started-btn-alex {
  color: #e71b44;
}
.vx-navbar-scroll .get-started-btn-others {
  color: #f29300;
}
.vx-logo-text {
  /* margin-left: 10rem; */
  /* GetBoarded */
  font-style: normal;
  font-weight: 500;
  font-size: 35px;
  line-height: 115%;
  /* identical to box height, or 51px */
  letter-spacing: -0.04em;
}
.alex-nav {
  margin-left: 10rem;
}
.gtb-nav {
  margin-left: 10rem;
}
.navbar-menu-item {
  /* Home Features Pricing Contact */
  font-style: normal;
  /*font-weight: 600;*/
  font-size: 15px;
  line-height: 22px;
  /* identical to box height */
}
.get-started-btn {
  margin-right: 12rem;
}
.alex-profile {
  margin-right: 14%;
  font-size: 35px;
  cursor: pointer;
}
.editor-iframe {
  width: 100%;
  height: calc(100vh - 150px);
}
.logo-gala {
  width: 200px;
  margin-left: 14%;
}
.dark-bg-gala {
  background: linear-gradient(180deg, #2d2c2c 0%, #121111 100%) !important;
}

.text-gear {
  background: linear-gradient(180deg,#0085ff 7.5%,#80c2ff 53.75%,#0085ff 100%);
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent;
  font-family: "El Messiri";
  font-style: normal;
  font-weight: 700;
}
/*===============================================*/
/* MEDIA QUERIES	 						 */
/*===============================================*/

@media (max-width: 1200px) {
  .vx-logo-text {
    margin-left: auto;
  }
}
@media (max-width: 600px) {
  .logo-gala {
    width: 150px;
    margin-left: 0px;
  }
  .alex-profile--sm {
    margin-right: 0 !important;
  }
  .gala-btn {
    padding: 0.5rem 1rem !important;
    width: 170px;
  }
  .router-content {
    margin-top: 4rem !important;
  }
}
</style>

